import styled from "styled-components";

import { CloseApplicationIcon, InfoIcon } from "../modal/modalIcons";
import { BasicInput } from "../../../styles/basicComponents";
import { CustomerMeteringPoint } from "../../../api/models/CustomerMeteringPoint";
import { Application } from "../../../api/models/Application";
import { Relation } from "../../../api/enums/Relation";
import { ApplicationStatus } from "../../../api/enums/ApplicationStatus";
import { RepresentationRequestType } from "../../../api/enums/RepresentationRequestType";
import { OpenApiRequestStatus, useOpenApiRequest } from "typescript-request-utils";
import { getApiRegistry } from "../../state/apiRegistry";
import { UserRepresentation } from "../../../api/models/UserRepresentation";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getCurrentUser } from "../../../features/basic/reducers/basicReducer";
import { useTheme } from "../../../features/context/CustomerContext";
import useCustomTranslation from "../../../features/hooks/CustomUseTranslation";

interface InputContainerProps {
    theme: any;
    customerTheme: any;
}

const MainDiv = styled.div`
    margin: 0 auto 0 auto;
    width: 100%;
    @media screen and (max-width: 800px) {
        margin: 0;
    }
`
const InputContainer = styled.div<InputContainerProps>`
    position: relative;
    padding: 17px;
    max-width: 500px;
    margin: auto;
    @media screen and (max-width: 650px) {
        padding-left: 0;
        padding-right: ${props => props.theme.hasError || props.theme.hasOwners ? "40px" : "0px"};
    }
    > input {
        border: 2px solid ${props => props.customerTheme.brandColor1};
    }
`
const InputTitle = styled.label`
    position: absolute;
    top: 11px;
    margin-left: 40px;
    background-color: #F4F5F5;
    padding: 0 10px 0 10px;
    color: #686868;
    z-index: 99;
    @media screen and (max-width: 600px) {
        margin-left: 20px;
    }
`
const Input = styled(BasicInput)`
    width: 100%;
    background-color: #F4F5F5 !important;
    border-color: #96008F;
    padding-left: 50px;
    @media screen and (max-width: 600px) {
        padding-left: 30px
    }
`
export const FieldValue = styled.span`

`

const ErrorMessageContainer = styled.div`
    text-align: left;
    padding: 17px;
    margin-left: ${props => props.theme.hasError || props.theme.hasOwners ? "70px" : "0px"};
    background-color: #EEEEEE;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 0px;
    @media screen and (max-width: 850px) {
        border-bottom-left-radius: 10px;
        margin-left: 0;
        margin-bottom: ${props => props.theme.hasError || props.theme.hasOwners ? "40px" : "0px"};
    }
`
const ApplicationContainer = styled.div`
    position: relative;
    background-color: ${props => props.theme.hasError ? "#D50000" : props.theme.hasOwners ? "#FFCD40" : "#EEEEEE"};
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 10px;
    @media screen and (max-width: 850px) {
        border-top-left-radius: 15px;
        border-bottom-left-radius: 10px;
    }
`
const ApplicationInputContainer = styled.div`
    padding: 17px;
    margin-left: ${props => props.theme.hasError || props.theme.hasOwners ? "70px" : "0px"};
    margin-right: ${props => props.theme.hasError || props.theme.hasOwners ? "0px" : "70px"};
    background-color: #F4F5F5;
    
    border-top-right-radius: 10px;
    border-bottom-right-radius: ${props => props.theme.hasError || props.theme.hasOwners ? "0px" : "10px"};
    border-top-left-radius: ${props => props.theme.hasError || props.theme.hasOwners ? "0px" : "10px"};
    border-bottom-left-radius: ${props => props.theme.hasError || props.theme.hasOwners ? "0px" : "10px"};
    @media screen and (max-width: 850px) {
        border-bottom-left-radius: 10px;
        margin-left: 0;
        margin-bottom: ${props => props.theme.hasError || props.theme.hasOwners ? "40px" : "0px"};
        border-top-left-radius: 10px;
        border-bottom-left-radius: ${props => props.theme.hasError || props.theme.hasOwners ? "0px" : "10px"};
    }
    @media screen and (max-width: 600px) {
        margin-right: ${props => props.theme.hasError || props.theme.hasOwners ? "0px" : "50px"};
    }
`
const AlreadyHasUserMessage = styled.p`
    font-weight: 400;
    margin: 0;
    padding: 10px 0 10px 39px;
    text-align: left;
    @media screen and (max-width: 850px) {
        padding: 10px 0 10px 5px;
    }
`
const OwnerUserListingText = styled.p`
    padding: 10px 0 0 39px;
    text-align: left;
    font-weight: 400;
    margin: 0;
    @media screen and (max-width: 850px) {
        padding: 10px 0 0 5px;
    }
`
const ClickHere = styled.a`
    color: #96008F;
    cursor: pointer;
    font-weight: 700;
    text-decoration: underline;
`
const ErrorRed = styled.span`
    font-weight: bold;
    color: red;
    padding-left: 39px;
    text-align: left;
    @media screen and (max-width: 850px) {
        padding-left: 5px;
    }
`
const ErrorMessageLinking = styled.p`
    font-weight: 500;
    padding-left: 39px;
    text-align: left;
    @media screen and (max-width: 850px) {
        padding-left: 5px;
    }
`
const ErrorMessage = styled.p`
    color: red;
    font-weight: 500;
    padding-left: 39px;
    text-align: left;
    @media screen and (max-width: 850px) {
        padding-left: 5px;
    }
`
export interface NewEnterpriseApplicationProps {
    id: number;
    customerMeteringPoint: CustomerMeteringPoint;
    setCustomerMeteringPoint: (customerMeteringPoint: CustomerMeteringPoint, id: number) => void;
    deleteMeteringPoint: (id: number) => void;
    handledApplication: (id: number) => void;
}

const NewEnterpriseApplication: React.FC<NewEnterpriseApplicationProps> = (props) => {

    const { t } = useCustomTranslation();
    const currentUserFromState = useSelector(getCurrentUser);

    const [userEmailToBeRemovedFromList, setUserEmailToBeRemovedFromList] = useState<string>('');
    const [currentUser, setCurrentUser] = useState<UserRepresentation>({});
    const [showApplicationError, setShowApplicationError] = useState<boolean>(false);

    const [applicationRequest, updateApplication] = useOpenApiRequest(getApiRegistry().applicationsApi.update);

    const customerTheme = useTheme();

    useEffect(() => {
        if (currentUserFromState) {
            setCurrentUser(currentUserFromState);
        }
        // eslint-disable-next-line
    }, [currentUserFromState]);

    useEffect(() => {
        if (applicationRequest.type === OpenApiRequestStatus.Complete) {
            props.handledApplication(props.id)
        }
        if (applicationRequest.type === OpenApiRequestStatus.Pending) {
            setUserEmailToBeRemovedFromList(applicationRequest.requestPayload[0].requesteeUsername);
        }
        if (applicationRequest.type === OpenApiRequestStatus.NetworkError || applicationRequest.type === OpenApiRequestStatus.ServerError) {
            if (props.customerMeteringPoint.ownerUsers) {
                props.setCustomerMeteringPoint({ ...props.customerMeteringPoint, ownerUsers: props.customerMeteringPoint.ownerUsers.filter(ownerUser => ownerUser.email !== userEmailToBeRemovedFromList) }, props.id)
            }
            setShowApplicationError(true);
        }
        // eslint-disable-next-line
    }, [applicationRequest])

    function createPersonalApplication(customerEmail: string | undefined) {
        const newApplication: Application = {
            requestorUser: currentUser,
            requesteeCustomerNumber: props.customerMeteringPoint.customerNumber ? props.customerMeteringPoint.customerNumber : "",
            requesteeUsername: customerEmail ? customerEmail : "",
            relation: Relation.REPRESENTATIVE,
            startDate: new Date(),
            status: ApplicationStatus.PENDING,
            representationRequestType: RepresentationRequestType.USER_REQUEST
        };
        updateApplication(newApplication);
    }

    return (
        <MainDiv>
            <ApplicationContainer theme={{ hasError: props.customerMeteringPoint.errorCode, hasOwners: props.customerMeteringPoint.ownerRelationExists }}>

                <ApplicationInputContainer theme={{ hasError: props.customerMeteringPoint.errorCode, hasOwners: props.customerMeteringPoint.ownerRelationExists }}>
                    <InputContainer customerTheme={customerTheme} theme={{ hasError: props.customerMeteringPoint.errorCode, hasOwners: props.customerMeteringPoint.ownerRelationExists }}>
                        <InputTitle htmlFor="customerNumberInput">{t("Customer number")}</InputTitle>
                        <Input
                            id="customerNumberInput"
                            type="number"
                            value={props.customerMeteringPoint.customerNumber || ""}
                            onChange={(e) => props.setCustomerMeteringPoint({ meteringPointNumber: props.customerMeteringPoint.meteringPointNumber, customerNumber: (e.target.value.replace(/\D/,'')) }, props.id)} />
                    </InputContainer>
                    <InputContainer customerTheme={customerTheme} theme={{ hasError: props.customerMeteringPoint.errorCode, hasOwners: props.customerMeteringPoint.ownerRelationExists }}>
                        <InputTitle htmlFor="placeOfUseIdInput">{t("Place of use ID")}</InputTitle>
                        <Input
                            id="placeOfUseIdInput"
                            type="text"
                            value={props.customerMeteringPoint.meteringPointNumber || ""}
                            onChange={(e) => props.setCustomerMeteringPoint({ customerNumber: props.customerMeteringPoint.customerNumber, meteringPointNumber: (e.target.value) }, props.id)} />
                    </InputContainer>
                    <CloseApplicationIcon onClick={() => props.deleteMeteringPoint(props.id)} />
                </ApplicationInputContainer>


                {(props.customerMeteringPoint.errorCode || props.customerMeteringPoint.ownerRelationExists) &&
                    <>
                        <InfoIcon />
                        <ErrorMessageContainer theme={{ hasError: props.customerMeteringPoint.errorCode, hasOwners: props.customerMeteringPoint.ownerRelationExists }}>
                            {props.customerMeteringPoint.errorCode &&
                            <>
                                <ErrorRed>{t("Error when trying to link enterprise")}</ErrorRed>
                                <ErrorMessageLinking>{t("ErrorMsgSecond")}</ErrorMessageLinking>
                                <ErrorMessageLinking>{t("ErrorMsgThirdEnterprise")}</ErrorMessageLinking>
                            </>}
                            {props.customerMeteringPoint.ownerRelationExists &&
                                <>
                                    <AlreadyHasUserMessage>
                                        {t("ErrorSendApplicationToEnterpriseUserFirst")}
                                        <b>{props.customerMeteringPoint.customerNumber}</b>
                                        {t("ErrorSendApplicationToEnterpriseUserSecond")}
                                    </AlreadyHasUserMessage>
                                    {showApplicationError &&
                                        <ErrorMessage>{t("ErrorSendingApplicationToEnterpriseUserFirst")}
                                        </ErrorMessage>}
                                    {(showApplicationError && props.customerMeteringPoint.ownerUsers && props.customerMeteringPoint.ownerUsers.length > 0) &&
                                        <ErrorMessage>{t("ErrorSendingApplicationToEnterpriseUserSecond")}
                                        </ErrorMessage>}
                                    {props.customerMeteringPoint.ownerUsers?.map((ownerUser, index) => (
                                        <OwnerUserListingText key={index}>
                                            {ownerUser.firstName} {ownerUser.lastName}, {t("requestRepresentation")}
                                            <ClickHere type="text" onClick={() => createPersonalApplication(ownerUser.email)}>
                                                {t("clickHere")}
                                            </ClickHere>
                                        </OwnerUserListingText>
                                    ))}
                                    <AlreadyHasUserMessage>
                                        {t("ErrorSendApplicationToEnterpriseUserThird")}
                                    </AlreadyHasUserMessage>
                                </>
                            }
                        </ErrorMessageContainer>
                    </>}
            </ApplicationContainer>
        </MainDiv>)
}

export default NewEnterpriseApplication